export const usersSubscriptionGroupsData = "/users/subscription_groups_data";
